import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import { VirtualTableProps } from './dx-react-grid';
import { useMemo } from 'react';

export function useReactDataGridLocalization() {
  const i18n = useScopedTranslation('uikit.react_grid');
  const localizationMessages: VirtualTableProps['messages'] = useMemo(() => {
    return { noData: i18n.t('no_results') } as VirtualTableProps['messages'];
  }, [i18n.i18n.language]);

  return localizationMessages;
}
